import React from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTabSwiper, { EcoTabSwiperItemProps } from 'eco-design/sections/eco-tab-swiper';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const TabSwiper: React.FC = ({}) => {
    const { t } = useLang('theProduct.TabSwiper');
    const { locale } = getLocal();
    const IS_JP = locale === 'jp';
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const items: EcoTabSwiperItemProps[] = [
        !IS_EU && {
            bottomContent: t('content1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748661804946/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748661804946/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748661804771/1-h5.jpg',
            tabLabel: t('tab1'),
            tabValue: 'A1',
        },
        {
            bottomContent: t('content2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748661805321/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748661805321/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748661805139/2-h5.jpg',
            tabLabel: t('tab2'),
            tabValue: 'A2',
        },
        {
            bottomContent: t('content3'),
            pc: IS_EU ? 'https://websiteoss.ecoflow.com/upload/image/1750657830175/3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1748661805748/3.jpg',
            pad: IS_EU ? 'https://websiteoss.ecoflow.com/upload/image/1750657830175/3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1748661805748/3.jpg',
            h5: IS_EU
                ? 'https://websiteoss.ecoflow.com/upload/image/1750657829922/3-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1748661805505/3-h5.jpg',
            tabLabel: t('tab3'),
            tabValue: 'A3',
        },
    ].filter(Boolean) as EcoTabSwiperItemProps[];

    return (
        <div className={`TabSwiper GtmModuleData-section`} id="TabSwiper" data-section-id="TabSwiper">
            <EcoSpace />
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <EcoTabSwiper className={style.comp} gtmTitle={t('title')} items={items} />
        </div>
    );
};
export default TabSwiper;
